import React from "react";
import styles from "./TabSwitcher.module.css";
import { AnalyticsTab } from "../types";

interface TabSwitcherProps {
    value: AnalyticsTab;
    onChange: (next: AnalyticsTab) => void;
    labelTracks: string;
    labelHubs: string;
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({ value, onChange, labelTracks, labelHubs }) => (
    <div className={styles.root} role="tablist" aria-label="Analytics scope">
        <button
            type="button"
            role="tab"
            aria-selected={value === "tracks"}
            className={`${styles.tab} ${value === "tracks" ? styles.tabActive : ""}`}
            onClick={() => onChange("tracks")}
        >
            {labelTracks}
        </button>
        <button
            type="button"
            role="tab"
            aria-selected={value === "hubs"}
            className={`${styles.tab} ${value === "hubs" ? styles.tabActive : ""}`}
            onClick={() => onChange("hubs")}
        >
            {labelHubs}
        </button>
    </div>
);

export default TabSwitcher;
